/**
 * Splits an array in two chunks, using nth to determine the length of the first one
 *
 * @param array - An array of ReactNode elements
 * @param nth - The index of the element that will be the last of the first chunk
 * @returns A splitted array
 */

export function splitAtNth(array: React.ReactNode[], nth: number | null) {
  if (array.length === 0) {
    return [];
  }
  if (nth === null || nth < 0) {
    return [];
  }

  const rest = array.slice(nth, array.length);
  return [array.slice(0, nth), rest.length && rest].filter(Boolean);
}
